import React from 'react';
import * as S from './CustomerNeeds.styles';
import CategoryBlock from './CategoryBlock/CategoryBlock';

const CustomerNeeds = () => {
    return(
        <S.CustomerNeedsMainWrap>
            <S.CustomerNeedsHeaderWrap>
                <S.CustomerNeedsHeadText>Everything Your Customer Needs!</S.CustomerNeedsHeadText>
                <S.CustomerNeedsSubText>Helping you find a perfect stay for everyone.</S.CustomerNeedsSubText>
            </S.CustomerNeedsHeaderWrap>
            <CategoryBlock />
        </S.CustomerNeedsMainWrap>
    )
}

export default CustomerNeeds;